
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { CommonSectionTitle } from '@Components/common';
import {
  FilterContent,
  LandingFiltersWrapper,
  PaginationWrapper,
} from '@Components/LandingPage/FilterSection/FilterSection.styled';
import Layout from '@Components/Layout';
import Pagination from '@Components/Pagination';
import ProductCard from '@Components/ProductCard';
import ProductCardLoader from '@Components/ProductCard/ProductCard.loader';
import GlobalCategories from '@Components/ProductsWithFilters/GlobalCategories';
import {
  CarProductsWrapper,
  ProductsListWrapper,
  ProductsWithFiltersWrapper,
} from '@Components/ProductsWithFilters/ProductsWithFilters.styled';
import RequestCustomItem from '@Components/RequestCustomItem';
import { useAuth } from '@Contexts/AuthContext/Auth.context';
import { _GetProducts } from '@Services/Products';
import { K_AllProducts } from '@Utils/ReactQuery.keys';
import { configureAxiosLocale } from 'lib/Axios';
import ReactQueryConfig from 'lib/ReactQueryConfig';
import { GetStaticPropsContext, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import React, { useCallback, useMemo, useState } from 'react';
import { dehydrate, QueryClient, useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Col, Container, Row } from 'styled-bootstrap-grid';

type Props = {};
const ProductsOffer: NextPage<Props> = () => {
  const router = useRouter();
  const { t } = useTranslation('common');
  const { locale } = useRouter();
  const { isTokenValid } = useAuth();
  const { data: categories } = useSelector((state: RootState) => state.categories);
  const [offset, setOffset] = useState<number>();
  const [current, setCurrent] = useState<number>(1);
  const [category_id, set_category_id] = useState<number>();
  const specialProductsKeys = useMemo(
    () => ({
      is_offer: true,
      limit: 16,
      category_id,
      offset,
    }),
    [category_id, offset]
  );

  const { data: products, isLoading } = useQuery(
    K_AllProducts({ ...specialProductsKeys, locale }),
    () => _GetProducts(specialProductsKeys),
    {
      enabled: isTokenValid,
      onSuccess: (data) => {
        setTotalProducts(data.count);
      },
    }
  );
  const [totalProducts, setTotalProducts] = useState(products?.count);

  const handleSelectCategory = useCallback((val?: number) => {
    set_category_id(val);
  }, []);

  return (
    <Layout seoData={{ title: t('discover-top-offers') }}>
      <CarProductsWrapper>
        <Container>
          <Row>
            <Col col={12}>
              <CommonSectionTitle>{t('discover-top-offers')}</CommonSectionTitle>
              <ProductsWithFiltersWrapper>
                {categories && (
                  <GlobalCategories firstLevel={true} categories={categories} callback={handleSelectCategory} />
                )}
                <LandingFiltersWrapper>
                  <Row justifyContent="center">
                    <Col col={12}>
                      <FilterContent>
                        <ProductsListWrapper fullHeight={true}>
                          {!isLoading ? (
                            Boolean(products?.results.length) ? (
                              products?.results.map((product) => <ProductCard data={product} key={product.id} />)
                            ) : (
                              <RequestCustomItem />
                            )
                          ) : (
                            [...new Array(16)].map((_, i) => <ProductCardLoader key={i + '_Landing_SPECIAL'} />)
                          )}
                        </ProductsListWrapper>
                        {Boolean(totalProducts) && (
                          <PaginationWrapper
                            style={{
                              justifyContent: 'center',
                            }}
                          >
                            <Pagination
                              total={totalProducts}
                              disabled={isLoading}
                              defaultPageSize={16}
                              pageSize={16}
                              defaultCurrent={1}
                              current={current}
                              showPrevNextJumpers={true}
                              showQuickJumper={false}
                              onChange={(pageNum: number) => {
                                setOffset(16 * (pageNum - 1));
                                setCurrent(pageNum);
                              }}
                            />
                          </PaginationWrapper>
                        )}
                      </FilterContent>
                    </Col>
                  </Row>
                </LandingFiltersWrapper>
              </ProductsWithFiltersWrapper>
            </Col>
          </Row>
        </Container>
      </CarProductsWrapper>
    </Layout>
  );
};

 async function _getStaticProps({ locale }: GetStaticPropsContext) {
  configureAxiosLocale(locale);
  const queryClient = new QueryClient(ReactQueryConfig);
  await queryClient.prefetchQuery(
    K_AllProducts({
      is_offer: true,
      limit: 12,
      locale,
    }),
    () =>
      _GetProducts({
        is_offer: true,
        limit: 12,
      })
  );

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 60, // In seconds
  };
}

export default ProductsOffer;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/offers',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  